import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@boma/app-config';
import { IOffer } from '@boma/website/shared/entities';

@Injectable({
  providedIn: 'root',
})
export class OfferService {
  private base: string;
  private version: string;
  constructor(
    @Inject(APP_CONFIG) private configuration: any,
    private httpClient: HttpClient,
  ) {
    this.base = configuration.apiRoute;
    this.version = configuration.apiVersion;
  }

  getOffers(
    productId: string,
    operatingEntityId: string = null,
    locationId: string | null = null,
    type: string = null,
  ) {
    let queryParams = [];
    let urlQuery = '';

    if (operatingEntityId) {
      queryParams.push(`operatingEntityId=${operatingEntityId}`);
    }
    if (locationId) {
      queryParams.push(`locationId=${locationId}`);
    }
    if (type) {
      queryParams.push(`type=${type}`);
    }

    if (queryParams.length > 0) {
      urlQuery = `?${queryParams.join('&')}`;
    }

    return this.httpClient.get<IOffer[]>(
      `${this.base}api/v${this.version}/Offers/${productId}${urlQuery}`,
    );
  }
}
